<!-- <ideal-loading-placeholder-effect></ideal-loading-placeholder-effect> -->

<!-- <div [withLoadingSkeleton]="false" [skeletonLayout]="'fixed-inline'"> -->

<button (click)="isItTrue.set(!isItTrue())">Toggle Loading</button>
<!-- <div [withLoadingSkeleton] [isLoading]="isItTrue()" skeletonWidth="100%" xskeletonHeight="29em" >

  <div>something that is loaded<br />casdad</div>
</div>
<div>Other stuff.....</div> -->

<div>
  <div withLoadingSkeleton="block" [isLoading]="isItTrue()" xskeletonWidth="32em" skeletonHeight="6.2em" style="width: 100%">
    <!-- <ng-template #loadingSkeleton>
      <div>This content is loading...</div>
    </ng-template> -->
    <div>something that is loaded<br />casdad</div>
  </div>
</div>

<div>Other stuff...........</div>
<!-- <div class="ph-layout ph-loading-effect">
  <div class="ph-shape-text"></div> -->
<!-- <div class="ph-shape-text"></div>
  <div class="ph-shape-text ph-3"></div>
  <div class="ph-shape-text"></div>
  <div class="ph-shape-text ph-2"></div>
  <div class="ph-shape-text"></div>
  <div class="ph-shape-text ph-3"></div>
  <div class="ph-shape-text"></div>
  <div class="ph-shape-text"></div>
  <div class="ph-shape-text ph-7"></div>
  <div class="ph-shape-text"></div>
  <div class="ph-shape-text"></div>
  <div class="ph-shape-text ph-3"></div>
  <div class="ph-shape-text"></div>
  <div class="ph-shape-text"></div>
  <div class="ph-shape-text ph-3"></div>
  <div class="ph-shape-text"></div>
  <div class="ph-shape-text"></div>
  <div class="ph-shape-text ph-3"></div>
  <div class="ph-shape-text"></div> -->
<!-- <span class="ph-shape-text "></span>
  <div class="ph-shape-text short empty"></div>
  <div class="ph-shape-text"></div> -->
<!-- <div class="ref">some test</div> -->
<!-- <div class="ph-shape-text long"></div> -->
<!-- <div class="ph-col">
    <div class="ph-shape-text"></div>
    <div class="ph-shape-text short empty"></div>
    <div class="ph-shape-text short"></div>
    <div class="ph-shape-text short"></div>
    <div class="ph-shape-text short"></div>
     <div class="ph-row">
       <div class="ph-shape-text short"></div>
       <div class="ph-shape-text short"></div>
       <div class="ph-shape-text short"></div>
       <div class="ph-shape-text short"></div>
     </div>
    <div class="ph-shape-text header"></div>
  </div> -->
<!-- <div class="ref">some test fsdfsd fsd fsdf sdfsd fsd fsdf </div> -->
<!-- <div class="ph-shape-text"></div> -->
<!-- <div class="ref">some test</div> -->
<!-- <div class="ph-shape-text long"></div> -->
<!-- <div class="ref">some test fsdfsd fsd fsdf sdfsd fsd fsdf </div> -->
<!-- <div class="ph-shape-text line"></div> -->
<!-- <div class="ph-shape-text short empty"></div> -->
<!-- <div class="ph-shape-text header"></div> -->
<!-- <div class="ph-shape-text"></div> -->
<!-- <div class="ref">some test</div> -->
<!-- <div class="ph-shape-text long"></div> -->
<!-- <div class="ref">some test fsdfsd fsd fsdf sdfsd fsd fsdf </div> -->
<!-- <div class="ph-shape-text line"></div> -->
<!-- </div> -->
